<script lang="ts">
import { defineComponent } from 'vue'
import TemplateSolutionFormLp from '@/components/_core/TemplateSolutionFormLp.vue'
import EventMain from './Main.vue'
import EventBreadcrumb from './Breadcrumb.vue'

export default defineComponent({
  name: 'EventApp',

  components: {
    TemplateSolutionFormLp,
    EventMain,
    EventBreadcrumb,
  },
})
</script>

<template>
  <TemplateSolutionFormLp>
    <template #breadcrumbHeader>
      <EventBreadcrumb />
    </template>

    <template #main>
      <EventMain />
    </template>
  </TemplateSolutionFormLp>
</template>
